import { call, put } from 'redux-saga/effects';
import { fetchJourneyVisitorMetrics } from 'api/WorkflowsAPI';
import { actions, FetchJourneyVisitorMetricsRequestAction } from '..';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { JourneyVisitorMetricsResponse } from 'modules/workflows/types';

type JourneyVisitorsMetricsResponse = {
  data: {
    getJourneyVisitorMetrics: JourneyVisitorMetricsResponse;
  };
  errors: string[];
};

// Used for fetching all journey visitor counts
export function* fetchJourneyVisitorMetricsSaga(action: FetchJourneyVisitorMetricsRequestAction) {
  const { workflowId, dateRange } = action.payload;
  const { endDateString, startDateString } = dateRange;
  try {
    const response: JourneyVisitorsMetricsResponse = yield call(
      fetchJourneyVisitorMetrics,
      workflowId,
      startDateString,
      endDateString,
    );
    const { data, errors } = response || {};
    if (errors?.length > 0) {
      const message = 'Error fetching journey visitor metrics. Please try again later.';
      yield put(addNegativeToastWithErrorId(message, 'fetchJourneyVisitorMetricsSaga'));
    } else {
      yield put(actions.fetchJourneyVisitorMetricsResponse(data?.getJourneyVisitorMetrics));
    }
  } catch {
    const message = 'Error fetching journey visitor metrics. Please try again later.';
    yield put(addNegativeToastWithErrorId(message, 'fetchJourneyVisitorMetricsSaga'));
  }
}
